/**
 * Function to sanitize the title
 * Ensures consistent styling for trademark symbols in UI components.
 *
 * ⚠️ Do not remove this:
 * - The ® (Registered trademark symbol) may render inconsistently across platforms.
 * - Wrapping it in <sup> ensures proper elevation and visual alignment with ™.
 * - This is a necessary workaround to maintain brand consistency until native rendering is fixed.
 *
 * @param {string} title - The input string containing the title
 * @returns {string} - The sanitized title with superscript styling applied
 */
export const sanitizeTitle = (title: string) => {
  const sanitizeTitle = title.replace(/&reg;/gi, '<sup>&reg;</sup>').replace(/®/gi, '<sup>&reg;</sup>').replace(/&trade;/gi, '<sup>&trade;</sup>').replace(/™/gi, '<sup>&trade;</sup>');
  return sanitizeTitle;
};